/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SettingValueType {
  Boolean = 'Boolean',
  Integer = 'Integer',
  String = 'String',
  DateTime = 'DateTime',
  TimeSpan = 'TimeSpan',
  Enum = 'Enum',
  EnumMultiSelect = 'EnumMultiSelect'
}
